module.exports = "/assets/js/d6fdd7236c9cdd1285b4a940c50da7d9.svg";